import esLocale from './es';
const messages = {
    es: esLocale,
};
export default { messages };
